export enum DocumentTypeEnum {
    DNI = 1,
    Passaport = 2,
}